import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalConfig } from 'shared/components/modal-dialog/modal-config.model';
import { ModalService } from './modal-dialog.service';

@Component({
  selector: 'app-modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalDialogComponent {
  constructor(private dialogRef: MatDialogRef<ModalDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: ModalConfig,
              private modalService: ModalService) {
  }

  closeModal() {
    this.dialogRef.close();
  }

  doNotShowChanged(event: MatCheckboxChange, id: string) {
    if (!event || !id) {
      throw new Error('Missing parameters for "Do not show again"');
    }
    const newValue = event?.checked;
    this.modalService.updateDoNotShowAgainState(id, newValue);
  }
}
